import { defineStore } from 'pinia';
import { useFavoritesStore, useMapStoreData, useMarkersStore } from '@/stores/index';

export const usePrintingStore = defineStore('printingStore', {
	state: () => ({
		printMap: null as any,
		mapImage: null as any,
		expressionMarkerPart: [] as any,
		pathName: null as any,
		printMarkersSource: null as any,
	}),
	actions: {
		async setUpTemplate() {
			const _this = this;
			this.expressionMarkerPart = [];
			const templateMarkerData = [];

			for (const item of useFavoritesStore().favoritesGeoJson) {
				const id: any = item.properties.id;

				if (Object.prototype.hasOwnProperty.call(item.properties, 'id')) {
					const markerData = (useMapStoreData().markers as any)[id];
					const category = markerData.properties.categories[0] + '-' + markerData.properties.categories[1];
					const imageCategory = useMarkersStore().categoryMarkersLook.get(category);

					templateMarkerData.push({
						title: markerData.properties.title,
						address: markerData.properties.address,
						opening_hours: markerData.properties.opening_hours,
						categoryImage: imageCategory,
						image: useMarkersStore().getMarkerImage(id, 'm'),
					});
				}
			}
			_this.printMarkersSource = templateMarkerData;
		},
	},
});
